/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileUpdateResponseDocumentTheme } from './profileUpdateResponseDocumentTheme';

export interface ProfileUpdateResponse {
  first_name: string;
  last_name: string;
  phone: string | null;
  timezone: string;
  avatar_url: string | null;
  document_theme: ProfileUpdateResponseDocumentTheme;
}
